import { Help } from '@meteor/help';
import { useUser } from '@meteor/state';
import { Outlet, useLocation } from 'react-router-dom';
import { extraPanelAtom } from '../newLayout/extra/atom';

export let RootLayout = () => {
  let { pathname } = useLocation();
  let isBuilder = pathname.endsWith('/builder') || pathname.includes('/builder/');

  useUser();

  return (
    <>
      <Outlet />

      {!isBuilder && (
        <Help
          type="dashboard"
          onFeedbackClick={() => extraPanelAtom.set('feedback')}
          onSupportClick={() => extraPanelAtom.set('support')}
        />
      )}
    </>
  );
};
